import React from "react";
import { Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";


const Python = () => {
  const bucketUrl = process.env.REACT_APP_BUCKET;
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="container text-center">
          <div className="row">
            <div className="col">
              <div className="TituloPrincipal">
                <br /> <h1>Curso de Python</h1>
              </div>
              <center>
                <hr className="linea-horizontal"></hr>
              </center>
            </div>
            <div className="col">
              <div className="Text_Buttons_Radio_buttons">
              </div>
            </div>
          </div>
        </div>

        <div class="table-container text-center">
          <table class="styled-table text-center">
            <thead>
              <tr>
                <th>#</th>
                <th>Tema</th>
                <th>Contenido</th>
                <th>Material Adicional</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>1</td>
                <td>
                  <p className="text-center">
                    <b>Tema 1: Introducción</b>
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/python/tema-1"
                  >
                    Ver PDF
                  </Button>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/doc/Material_complementario_tema_1.docx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar
                  </a>{" "}
                </td>
              </tr>

              <tr>
                <td>2</td>
                <td>
                  <p className="text-center">
                    <b>Tema 2: Primeros Conceptos</b>
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/python/tema-2"
                  >
                    Ver PDF
                  </Button>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/doc/Material_complementario_tema_2.docx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar
                  </a>{" "}
                </td>
              </tr>

              <tr>
                <td>3</td>
                <td>
                  <p className="text-center">
                    <b>Tema 3: Programación Básica</b>
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/python/tema-3"
                  >
                    Ver PDF
                  </Button>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/doc/Material_complementario_tema_3.docx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar
                  </a>{" "}
                </td>
              </tr>

              <tr>
                <td>4</td>
                <td>
                  <p className="text-center">
                    <b>Tema 4: Funciones</b>
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/python/tema-4"
                  >
                    Ver PDF
                  </Button>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/doc/Material_complementario_tema_4.docx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar
                  </a>{" "}
                </td>
              </tr>

              <tr>
                <td>5</td>
                <td>
                  <p className="text-center">
                    <b>Tema 5: Organización de Código</b>
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/python/tema-5"
                  >
                    Ver PDF
                  </Button>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/doc/Material_complementario_tema_5.docx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar
                  </a>{" "}
                </td>
              </tr>

              <tr>
                <td>6</td>
                <td>
                  <p className="text-center">
                    <b>Tema 6: Aspectos Avanzados</b>
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/python/tema-6"
                  >
                    Ver PDF
                  </Button>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/doc/Material_complementario_tema_6.docx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar
                  </a>{" "}
                </td>
              </tr>

              <tr>
                <td>7</td>
                <td>
                  <p className="text-center">
                    <b>Tema 7: Análisis de Datos</b>
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/python/tema-7"
                  >
                    Ver PDF
                  </Button>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/doc/Material_complementario_tema_7.docx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar
                  </a>{" "}
                </td>
              </tr>

              <tr>
                <td>8</td>
                <td>
                  <p className="text-center">
                    <b>Tema 8: Visualización de Datos</b>
                  </p>
                </td>
                <td>
                  <Button
                    className="boton"
                    variant="primary"
                    as={Link}
                    to="/python/tema-8"
                  >
                    Ver PDF
                  </Button>
                </td>
                <td>
                  <a
                    className="btn btn-primary boton"
                    href={`${bucketUrl}/doc/Material_complementario_tema_8.docx`}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar
                  </a>{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Container>
    </>
  );
};

export default Python;